import { RECORD_STATUS } from '../models/record-status';
import { ResourceText } from '../models/resource-text';

const addResourceText = (items, resourceId, textCategoryId, push = false) => {
  if (!Array.isArray(items) || items.filter(obj => !(obj instanceof ResourceText)).length > 0) {
    throw new Error('Invalid items param supplied to addResourceText');
  }
  if (typeof resourceId !== 'number') {
    throw new Error('Invalid resourceId param supplied to addResourceText');
  }
  if (typeof textCategoryId !== 'number') {
    throw new Error('Invalid textCategoryId param supplied to addResourceText');
  }

  const ids = items.filter(obj => obj.resourceTextId < 0).map(obj => obj.resourceTextId).sort((a, b) => b - a);
  const result = new ResourceText({
    resourceTextId: (ids.length > 0 ? ids[0] : 0) - 1,
    resourceId: resourceId,
    textCategoryId: textCategoryId,
    textValue: '',
    dateAdded: new Date(),
    dateAmended: new Date(),
    status: RECORD_STATUS.added,
    allowAdd: false,
    allowRemove: false
  });

  if (push === false) {
    items.unshift(result);
  } else {
    items.push(result);
  }

  return result;
};

const deleteResourceText = (items, item) => {
  if (!Array.isArray(items) || items.filter(obj => !(obj instanceof ResourceText)).length > 0) {
    throw new Error('Invalid items param supplied to deleteResourceText');
  }
  if (!(item instanceof ResourceText)) {
    throw new Error('Invalid item param supplied to deleteResourceText');
  }

  if (item.status === RECORD_STATUS.added) {
    items.splice(items.indexOf(item), 1);
  } else {
    item.status = RECORD_STATUS.deleted;
  }
};

const editResourceText = (item) => {
  if (!(item instanceof ResourceText)) {
    throw new Error('Invalid item param supplied to editResourceText');
  }

  item.status = item.status === RECORD_STATUS.added
    ? item.status
    : RECORD_STATUS.edited;
};

export { addResourceText, deleteResourceText, editResourceText };